import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import Pagination from "react-paginate";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import AdminHelpers from "../../services/admin/admin.service";
import userService from "../../services/user.service";
import { getFullDate } from "../../utils/classOfDegree";
import Adminroutes from "./routes";

const AdminShortlistedApplicants = () => {
  const navigate = useNavigate();
  const [gender, setGender] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [traineeId, setTraineeId] = useState("");
  const [allApplicants, setAllApplicants] = useState<any>([]);
  const [filteredApplicants, setFilteredApplicants] = useState<any>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [isEnrol, setEnrol] = useState(false);
  const [reload, setReload] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  // User is currently on this page
  const [currentPage, setCurrentPage] = useState(0);
  // No of Records to be displayed on each page
  const [recordsPerPage, setRecordsPerPage] = useState(15);
  // Records to be displayed on the current page
  const currentRecords: any = filteredApplicants.slice(
    currentPage * recordsPerPage,
    (currentPage + 1) * recordsPerPage
  );
  const nPages = Math.ceil(filteredApplicants.length / recordsPerPage);

  useEffect(() => {
    try {
      AdminHelpers.getShortlistedApplicants().then(async (res) => {
        setAllApplicants(res.data);
        setFilteredApplicants(res.data);

        console.log(res.data, "hereeee");
        setLoading(false);
      });
    } catch (e) {}
  }, []);

  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    console.log(searchTerm, "search term");
    if (!searchTerm) {
      setFilteredApplicants(allApplicants);
    } else {
      if (allApplicants) {
        const filtered = allApplicants.filter((each: any) =>
          each.user?.name.toLowerCase().includes(searchTerm)
        );
        console.log(filtered, "hhehehe")
        setFilteredApplicants(filtered);

        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  const viewCourseApplication = async (course_id: string) => {
    navigate(Adminroutes.ReviewApplicationLink(course_id));
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected);
  };

  return (
    <>
      <Flex
        minHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}
      >
        <Box
          width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
          position="relative"
          top="0"
          left="0"
          zIndex="100"
        >
          <AdminSidebar />
        </Box>

        <Box width="100%">
          <AdminDashboardHeader />
          <Box
            pt="30px"
            px={["20px", "30px"]}
            width={"100%"}
            bg="#F9F8F8"
            height={"auto"}
            minHeight={"95vh"}
            maxHeight={"95vh"}
            overflowX={"scroll"}
            className="scroll-hidden"
          >
            <Flex justifyContent="space-between" alignItems="center" py="26px">
              <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                Shortlisted Applicants
              </Box>
            </Flex>
            <Flex py="15px" justifyContent="">
              <InputGroup
                color="brand.subtitle"
                bg="white"
                width={["90%", "90%", "50%", "30%"]}
              >
                <Input
                  height="40px"
                  placeholder="Search applicants by name"
                  onChange={(e) => handleSearchChange(e)}
                  fontSize={12}
                  size="sm"
                />

                <InputRightElement
                  pointerEvents="none"
                  children={<RiSearch2Line color="red" size="0.9rem" />}
                />
              </InputGroup>
            </Flex>
            <Box width="100%">
              {loading ? (
                <Loading />
              ) : (
                <TableContainer>
                  <Table variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">Applicant</Th>
                        <Th textTransform="none">Applicant ID</Th>
                        <Th textTransform="none">Applicant Course</Th>
                        <Th textTransform="none">Email Address</Th>
                        <Th textTransform="none">Date Shortlisted</Th>
                        {/* <Th textTransform="none">Options</Th> */}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {currentRecords &&
                        currentRecords.map((each: any) => (
                          <Tr bg="white" key={each.id}>
                            <Td>
                              <HStack spacing="10px">
                                <Avatar name={each.user?.name} size="sm" />
                                <Text
                                  fontWeight="600"
                                  fontSize="16px"
                                  color="#616161"
                                >
                                  {each.user?.name}
                                  <br></br>
                                </Text>
                              </HStack>
                            </Td>
                            <Td>
                              {" "}
                              <Text>{each.user?.code}</Text>
                            </Td>
                            <Td>
                              <Text>{each.course?.name}</Text>
                            </Td>
                            <Td>
                              <Text>{each.user?.email}</Text>
                            </Td>
                            <Td>
                              {" "}
                              <Text>
                                {getFullDate(each.application_approved_at)}
                              </Text>
                            </Td>
                            {/* <Td textTransform='capitalize' >
                                                              <HStack cursor='pointer' onClick={() => viewCourseApplication(each.uuid)} width='116px' border='1px solid' borderColor='lightgray' borderRadius='10px' py='6px' px='16px' color='#EC3337' spacing='10px'>
                                                                  <RiEyeLine fontWeight='700' fontSize='18px' />
                                                                  <Text fontWeight='600' fontSize='16px'>Review</Text>
                                                              </HStack>
                                                          </Td> */}
                          </Tr>
                        ))}
                    </Tbody>
                  </Table>
                  {currentRecords.length > 0 && (
                    <Flex
                      pb="1rem"
                      flexDirection={"row"}
                      alignItems={"center"}
                      width="100%"
                      justifyContent={"center"}
                    >
                      <Pagination
                        breakLabel="..."
                        nextLabel={<ArrowRightIcon style={{ fontSize: 14 }} />}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={5}
                        pageCount={nPages}
                        previousLabel={
                          <ArrowLeftIcon style={{ fontSize: 14 }} />
                        }
                        containerClassName="pagination2"
                        pageLinkClassName="page-num2"
                        previousLinkClassName="page-num2"
                        nextLinkClassName="page-num2"
                        activeLinkClassName="active2"
                      />
                    </Flex>
                  )}
                </TableContainer>
              )}
            </Box>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default AdminShortlistedApplicants;
